import React, { useRef, useEffect, useState } from 'react';
import FullScreenIcon from '../../features/common/FullScreenIcon/FullScreenIcon';
import './NoAccessWidget.scss';
import { ReactComponent as EmptyStateIcon } from '../../images/no-data.svg';
import { ReactComponent as InfoCircleBlueIcon } from '../../images/info-circle-blue.svg';


const NoAccessWidget: React.FC<{ widgetName: string, widgetMessage?: string, infoIcon?: boolean }> = ({ widgetName, widgetMessage, infoIcon }) => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const containerRef = useRef<HTMLElement>(null);

    // Handle fullscreen change events
    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, []);

    // Toggle fullscreen
    const toggleFullscreen = () => {
        if (!containerRef.current) return;

        if (!document.fullscreenElement) {
            containerRef.current.requestFullscreen().catch((err) => {
                console.error(`Error attempting to enable fullscreen: ${err.message}`);
            });
        } else {
            document.exitFullscreen();
        }
    };

    return (
        <div className='main-container'>
            <section
                ref={containerRef}
                className={`ogl-chart-container ${isFullscreen ? 'fullscreen' : ''}`}
                style={!isFullscreen ? { background: 'transparent' } : undefined}
            >
                <header className='ogl-chart-header'>
                    <div className='chart-title'>
                        <h2>{widgetName}</h2>
                    </div>
                    <div className='chart-actions'>
                        <button className='chart-action-button' onClick={toggleFullscreen}>
                            <FullScreenIcon />
                        </button>
                    </div>

                </header>
                <div className='chart-divider'></div>
                <div id='ogl-chart-content'>
                    <div className='chart-area'>
                        <section className='no-access-state'>
                            {infoIcon ? (
                                <div className='no-access-state__info-icon'>
                                    <div className='no-access-state__info-icon-outer'>
                                        <div className='no-access-state__info-icon-outer-inner'>
                                            <InfoCircleBlueIcon />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className='no-access-state__icon'>
                                    <EmptyStateIcon />
                                </div>
                            )}
                            <p className='no-access-state__message'>
                                {widgetMessage || 'You do not have access to this widget.'}
                            </p>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default React.memo(NoAccessWidget);
